import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	value: {},
	permissions: [],
};

const currentUserSlice = createSlice({
	name: 'currentUser',
	initialState,
	reducers: {
		setCurrentUser: (state, currentUser) => {
			state.value = currentUser.payload;
		},
		setPermissions: (state, currentUser) => {
			state.permissions = currentUser.payload;
		},
	},
});

export const { setCurrentUser, setPermissions } = currentUserSlice.actions;

export default currentUserSlice.reducer;
